import { RepresentInterface } from '../../interfaces/interfaces';

import './styles.scss';

export function Repre({ id, repreName, repreMail, onClick }: RepresentInterface) {
  return (
    <button className="itens-container-representante" onClick={onClick}>
      <span className="itens-container-representante-title" >
        {id}
      </span>
    </button>
  );
}